import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import classNames from 'classnames';

import CardListLoader from '../cardlistloader';
import ChatInterfaceLoader from '../../chatinterface/loaders/index';
import ProfileCardLoader from '../../profilecard/loader/index';

export default class ConversationLoader extends React.PureComponent {
  render() {
    const { screen_width } = this.props;
    const is_mobile = screen_width < 768;
    const is_tablet = screen_width >= 768 && screen_width <= 1024;

    return (
      <div className="ori-full-width ori-flex-column" style={{ height: `calc(100vh - 60px)` }}>
        <div className="ori-full-width ori-full-flex ori-overflow-hidden conversationBodyContainer">
          <Col xs={24} md={is_tablet ? 9 : 6} className="ori-full-parent-height  ori-r-border-light ori-bg-white">
            <CardListLoader />
          </Col>
          <Col xs={24} md={is_tablet ? 15 : 12} className=" ori-mobile-hidden" style={{ height: `calc(100vh - 60px)` }}>
            <ChatInterfaceLoader />
          </Col>
          <Col xs={24} md={6} className={classNames("ori-l-border-light ori-tb-pad-10 ori-full-parent-height ori-bg-white", { 'ori-display-none': is_mobile || is_tablet })}>
            <ProfileCardLoader />
          </Col>
        </div>
      </div >
    );
  }
}

ConversationLoader.propTypes = {
  screen_width: PropTypes.number,
};




// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/loaders/conversationloader/index.js